import { Row } from "@circle-react-uikit/SkeletonLoader/components/Row";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { Button } from "@circleco/compass/components/Button";

import { t } from "@/i18n-js/instance";

import { OFFER_PAGE_LOCALE_ROOT } from "./constants";
import { useConfirmAndDeclineButton } from "./hooks/useConfirmAndDeclineButton";

interface ConfirmAndDeclineButtonProps {
  className?: string;
  layout?: "inline" | "sticky";
}

export const ConfirmAndDeclineButton = Object.assign(
  ({ className, layout = "inline" }: ConfirmAndDeclineButtonProps) => {
    const isSticky = layout === "sticky";
    const {
      shouldBlockButtons,
      handleConfirm,
      isProcessingAttempt,
      handleDecline,
      isProcessingRefusal,
    } = useConfirmAndDeclineButton();

    return (
      <div
        className={classNames(
          "flex w-full flex-col items-center",
          {
            "gap-y-2 [@container(min-width:768px)]:gap-y-3": isSticky,
            "gap-y-4": !isSticky,
          },
          className,
        )}
      >
        <Button
          data-testid="upsell-confirm-button"
          variant="primary"
          fullWidth
          size={isSticky ? "md" : "lg"}
          disabled={shouldBlockButtons}
          loading={isProcessingAttempt}
          type="button"
          onClick={handleConfirm}
        >
          {t([OFFER_PAGE_LOCALE_ROOT, "confirm_add_to_my_order"])}
        </Button>
        <div className={classNames({ "w-full": isSticky, "w-1/2": !isSticky })}>
          <Button
            data-testid="upsell-decline-button"
            fullWidth
            variant="ghost"
            size={isSticky ? "md" : "lg"}
            disabled={shouldBlockButtons}
            loading={isProcessingRefusal}
            type="button"
            onClick={handleDecline}
          >
            {t([OFFER_PAGE_LOCALE_ROOT, "no_thank_you"])}
          </Button>
        </div>
      </div>
    );
  },
  {
    Skeleton: () => (
      <div
        className={classNames(
          "flex flex-col gap-y-4 items-center w-full md:w-[540px]",
        )}
      >
        <Row full x2l />
        <Row half x2l />
      </div>
    ),
  },
);
